import React, { useState } from 'react';

import FaultCardsContainer from './FaultCardsContainer';
import HealthPanel from './HealthPanel';
import TreePanel from './TreePanel';

import SubscriptionModal from '../Modals/SubscriptionModal';
import CreateServiceRequestModal from '../Modals/CreateServiceRequestModal';

import usePermissions from '../../hooks/usePermissions';

import classes from './ListView.module.css';

const ListView = ({
    rule,
    ...props
}) => {

    const [subscriptionModalOpen, setToggleSubscriptionModal] = useState(false);
    const [createServiceRequestModalOpen, setToggleCreateServiceRequestModal] = useState(false);

    const handleToggleSubscriptionModal = toggleState => {
        setToggleSubscriptionModal(toggleState);
    };

    const handleToggleCreateServiceRequestModal = toggleState => {
        setToggleCreateServiceRequestModal(toggleState);
    };


    return (
        <React.Fragment>
            <div className={classes.ListView}>
                <TreePanel
                    onToggleSubscriptionModal={handleToggleSubscriptionModal}
                    onToggleCreateServiceRequestModal={handleToggleCreateServiceRequestModal}
                />
                <FaultCardsContainer />
                <HealthPanel
                    onToggleCreateServiceRequestModal={handleToggleCreateServiceRequestModal}
                />
            </div>
            <SubscriptionModal
                open={subscriptionModalOpen}
                close={() => handleToggleSubscriptionModal(false)}
                title="Subscribe to Alerts"
            />
            { usePermissions('serviceManagementRead') &&
                <CreateServiceRequestModal
                    open={createServiceRequestModalOpen}
                    close={() => handleToggleCreateServiceRequestModal(false)}
                    title="Create Service Request"
                    rule={rule}
                />
            }
        </React.Fragment>
    );
};

export default ListView;
